// eslint-disable-next-line import/no-unresolved
import * as Sentry from "@sentry/react";

window._nounConfig = window._nounConfig || {};

const IGNORE_LIST_UNHANDLED = [
    "Event `CustomEvent`", // this happens a lot, seems to be 3rd party
    "Object Not Found Matching Id", // this seems to be outlook scanning for malicious links
];

const sentryConfig = {
    dsn: window._nounConfig.sentryDSN,
    debug: window._nounConfig.debugMode,
    release: window._nounConfig.release,
    environment: window._nounConfig.environment,
    ignoreErrors: [
        "Cannot read property 'undefined' of undefined",
        "AMCore is not defined",
    ],
    allowUrls: [
        // eslint-disable-next-line no-useless-escape
        /static\.(test|staging|production)?\.?thenounproject\.com\/assets\/bundles\/[a-z0-9\-]*.js/,
    ],
    // Equivalent to shouldSendCallback
    beforeSend(event) {
        // Log errors for the dev environment, but don't send to Sentry
        if (window._nounConfig.environment === "dev") {
            console.log("Sentry error not sent because environment=dev", event);
            return null;
        }

        // Modify the event here

        const mechanismType = event.exception?.values?.[0]?.mechanism?.type;
        if (mechanismType === "onunhandledrejection") {
            const value = event.exception?.values?.[0]?.value || "";
            if (IGNORE_LIST_UNHANDLED.map(e => value.includes(e))) {
                return null;
            }
        }

        return event;
    },
};

// Let exceptions from webpack files through to Sentry handling code in development
// but stop them from actually being sent in shouldSendCallback
if (process.env.NODE_ENV != "production") {
    sentryConfig.allowUrls.push(/webpack/);
}

const sentryDisabled = localStorage.getItem("DISABLE_JS_SENTRY");

if (sentryDisabled) {
    console.warn("Sentry disabled.");
} else {
    // Old plugins use `pluginHost` - new plugins use `pluginType`
    const plugin = window._nounConfig?.pluginHost || window._nounConfig?.pluginType;
    if (plugin) {
        Sentry.setTag("plugin", plugin);
    }

    Sentry.init(sentryConfig);
}
